import React from "react";
import { FaPaperPlane, FaPaperclip } from "react-icons/fa";
import FileUpload from "../FileUpload";
import AudioRecorder from "./AudioRecorder";

const MessageInput = ({
  input,
  handleInputChange,
  handleKeyPress,
  handlePostRequest,
  handleFileUpload,
  handleAudioUpload,
  attachedFile,
  setAttachedFile,
  userId,
  chatBotId,
  disabled = false,
  placeholder = "Type a message",
  subscriptionStatus = null,
}) => {
  return (
    <div className="flex mt-4 w-full">
      <div className="flex-grow flex flex-col">
        {attachedFile && (
          <div className="mb-2 px-3 py-2 bg-gray-700 rounded-lg flex items-center justify-between">
            <span className="text-sm text-gray-200">{attachedFile.name}</span>
            <button
              onClick={() => setAttachedFile(null)}
              className="text-gray-400 hover:text-gray-200"
            >
              ×
            </button>
          </div>
        )}
        <div className="flex items-center bg-gray-800 bg-opacity-50 rounded-lg shadow-lg border border-gray-700">
          <input
            type="text"
            value={input}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            placeholder={
              subscriptionStatus && !subscriptionStatus.canSendMessages && subscriptionStatus.type === 'subscription_required'
                ? "Subscribe to Sam to send messages to any character"
                : placeholder
            }
            disabled={disabled}
            className={`flex-grow p-3 bg-transparent text-white placeholder-gray-400 focus:outline-none ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
          />
          <AudioRecorder
            onAudioUpload={handleAudioUpload}
            userId={userId}
            chatBotId={chatBotId}
            disabled={disabled}
          />
          <FileUpload
            onFileUpload={handleFileUpload}
            userId={userId}
            chatBotId={chatBotId}
            disabled={disabled}
          />
          <button
            onClick={handlePostRequest}
            disabled={disabled || (!input.trim() && !attachedFile)}
            className={`p-3 rounded-r-lg transition-all duration-200 flex items-center justify-center ${
              disabled
                ? "text-gray-500 cursor-not-allowed"
                : input.trim() || attachedFile
                  ? "text-blue-500 hover:text-blue-400"
                  : "text-gray-500"
            }`}
          >
            <FaPaperPlane size={20} />
          </button>
        </div>
        
        {/* Subscription Upgrade Prompt */}
        {subscriptionStatus && !subscriptionStatus.canSendMessages && subscriptionStatus.type === 'subscription_required' && (
          <div className="mt-2 p-3 bg-blue-900 bg-opacity-30 border border-blue-600 rounded-lg">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <svg className="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span className="text-blue-200 text-sm">
                  Subscribe to Sam for unlimited messaging with all characters
                </span>
              </div>
              <a
                href="/subscription-management"
                className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-3 py-1 rounded transition-colors ml-3"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = '/subscription-management';
                }}
              >
                Subscribe
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageInput;
